import { Component, EventEmitter, Output } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpClient } from "@angular/common/http";
import { PointService } from "../../../../shared/services/point.service";

@Component({
    selector: 'app-add-point-component',
    templateUrl: './add-point-component.html',
})
export class AddPointComponent {
    constructor(protected http: HttpClient,
                public toastr : ToastrService,
                public pointService : PointService,
                public activeModal: NgbActiveModal,
                protected _modalService: NgbModal) {
    }
    
    @Output()
    onRefresh: EventEmitter<any> = new EventEmitter<any>();
    
    model = {
        point : null,
        customerId: null,
        eventId: 1,
        operator: '+'
    };

    ngOnInit() {

    }
    
    addPoint(form) {
        if (form.valid) {
            this.pointService.addEventPoint(this.model).subscribe(() => {
                this.activeModal.close();
                this.toastr.success('Add point successfully', 'SUCCESS');
                setTimeout((res) => {
                    this.onRefresh.emit();
                }, 1000)
               
            })
        }
    }
}
